import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const cancelSensorOrder = async (projectId, orderId) => {
  const apiPath = `projects/${projectId}/renolog/sensor-orders/${orderId}/cancel`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
  });

  const response = await axios(signedRequest);
  return response.data;
};
